// Content for the Resources page

export const RESOURCES_SUBTITLE = "Helpful videos and legal links, all in one place.";

export interface ResourceLink {
	name: string;
	url: string;
}

export interface ResourceLinkGroup {
	county: string;
	links: ResourceLink[];
}

// Court, clerk, sheriff, and jail links for each county, shown as cards on the Resources page
export const resourceLinkGroups: ResourceLinkGroup[] = [
	{
		county: "Harris County",
		links: [
			{ name: "Harris County District Clerk", url: "https://www.hcdistrictclerk.com/Common/Default.aspx" },
			{ name: "Harris County Clerk", url: "https://www.cclerk.hctx.net/" },
			{ name: "Harris County Sheriff", url: "https://harriscountyso.org/" },
			{ name: "Harris County Jail Inmate Locator", url: "https://harriscountyso.org/JailInfo/FindSomeoneInJail" },
			{ name: "Harris County Criminal Case Information", url: "https://myharriscountycase.com/" },
		],
	},
	{
		county: "Brazoria County",
		links: [
			{ name: "Brazoria County District Clerk", url: "https://www.brazoriacountytx.gov/departments/district-clerk" },
			{ name: "Brazoria County Clerk", url: "https://www.brazoriacountyclerktx.gov/" },
			{ name: "Brazoria County Sheriff", url: "https://www.brazoriacountytx.gov/departments/sheriff-s-office" },
			{ name: "Brazoria County Jail Records Inquiry", url: "https://portal-txbrazoria.tylertech.cloud/JailAccess/default.aspx" },
			{ name: "Brazoria County Court Records Inquiry", url: "https://portal-txbrazoria.tylertech.cloud/PublicAccess/default.aspx" },
		],
	},
	{
		county: "Fort Bend County",
		links: [
			{ name: "Fort Bend County District Clerk", url: "https://www.fortbendcountytx.gov/government/departments/fort-bend-county-district-clerks-office" },
			{ name: "Fort Bend County Clerk", url: "https://www.fortbendcountytx.gov/government/departments/county-clerk" },
			{ name: "Fort Bend County Sheriff", url: "https://www.fortbendcountytx.gov/government/departments/sheriff-s-office" },
			{ name: "Fort Bend County Inmate Search", url: "https://jailinq.fortbendcountytx.gov/" },
			{ name: "Fort Bend County Court Records", url: "https://www.fortbendcountytx.gov/government/courts/court-records-research" },
		],
	},
	{
		county: "Galveston County",
		links: [
			{ name: "Galveston County District Clerk", url: "https://www.galvestoncountytx.gov/our-county/district-clerk" },
			{ name: "Galveston County Clerk", url: "https://www.galvestoncountytx.gov/our-county/county-clerk/county-clerk-86" },
			{ name: "Galveston County Sheriff", url: "https://sheriff.galvestoncountytx.gov/index.html" },
			{ name: "Galveston County Inmate Inquiry Tool", url: "https://p2c.galvestoncountytx.gov/jailinmates.aspx" },
			{ name: "Galveston County Court Records Search", url: "https://portalnav19.galvestoncountytx.gov/portal" },
		],
	},
	{
		county: "Montgomery County",
		links: [
			{ name: "Montgomery County District Clerk", url: "https://www.mctx.org/departments/departments_d_-_f/district_clerk/index.php" },
			{ name: "Montgomery County Clerk", url: "https://www.mctx.org/index_clerk.php" },
			{ name: "Montgomery County Sheriff", url: "https://www.mctxsheriff.org/" },
			{ name: "Montgomery County Jail Inquiry", url: "https://www.mctxsheriff.org/divisions/jail_division/index.php" },
			{ name: "Montgomery County Case Records Search", url: "https://www.mctx.org/departments/departments_d_-_f/district_clerk/inquiry_index.php" },
		],
	},
];
